module.exports = __webpack_public_path__ + "static/img/hr_visitor_carddesc12.28a7d0cc.png";